import querystring from 'querystring';
import axios from 'axios';
import { API } from '../utils/constants';
import { setAntiForgeryToken } from '../utils/forms';

export const trackEvent = (goalId, antiForgeryData) => {
  var queryString = '?goalId=' + goalId.goalId;

  return axios
    .post(
      API.CLIENT_EVENT_TRACKER + queryString,
      setAntiForgeryToken(antiForgeryData, goalId),
    )
    .then(({ jsonObject }) => [null, jsonObject])
    .catch(error => [error, null]);
};
